import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import FeaturedProducts from './components/FeaturedProducts';
import CategoryShowcase from './components/CategoryShowcase';
import BrandIntro from './components/BrandIntro';
import FeaturedArticles from './components/FeaturedArticles';
import FAQ from './components/FAQ';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '亚洲精品——甄选顶级亚洲精品购物平台',
            description: '亚洲精品汇聚日韩、东南亚、中华等顶级品牌与匠心工艺，为您精选最具品质代表性的亚洲精品。',
            url: 'https://pcnqq.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '亚洲精品',
              url: 'https://pcnqq.cn/',
            },
          }),
        }}
      />
      <main>
        <Hero />
        <CategoryNav />
        <FeaturedProducts />
        <CategoryShowcase />
        <BrandIntro />
        <FeaturedArticles />
        <FAQ />
      </main>
    </>
  );
}